/**
 *
 * ModalContent
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import { useSelector } from 'react-redux';
import { makeSelectClientDetails } from 'containers/Main/selectors';
import ModalLogin from './ModalLogin';
import ModalSignUp from './ModalSignUp';
import ModalSubscription from './ModalSubscription';

const ModalContent = ({ action, onClose, onSignUp, profile, type }) => {
  const isLogin = action !== 'sign-up';
  const clientDetails = useSelector(makeSelectClientDetails());

  if (
    !profile.isEmpty &&
    _get(profile, 'providerData.providerId') !== 'password' &&
    !_get(clientDetails, 'metadata.hideSubscription') &&
    !_get(clientDetails, 'metadata.requirePersonalEmail')
  )
    return <ModalSubscription onClose={onClose} />;

  return isLogin ? (
    <ModalLogin onClose={onClose} onSignUp={onSignUp} type={type} />
  ) : (
    <ModalSignUp onClose={onClose} onSignUp={onSignUp} type={type} />
  );
};

ModalContent.propTypes = {
  action: PropTypes.string,
  onClose: PropTypes.func,
  onSignUp: PropTypes.func,
  profile: PropTypes.object,
  type: PropTypes.string,
};

export default ModalContent;
